<template>
  <van-overlay :show="showOverlay">
    <div class="wrapper">
      <div class="block">
        <van-circle
          v-model:current-rate="currentRate"
          :rate="rate"
          :text="rate + '%'"
          :clockwise="false"
          size="52px"
        />
      </div>
    </div>
  </van-overlay>
  <div class="chooseDifficulty" v-if="showChooseDifficulty">
    <van-popup
      v-model:show="showChoose"
      class="chooseDifficultyPopup"
      round
      position="bottom"
      closeable
      close-icon="close"
      :style="{ height: '60%', padding: '1.5rem 0 ' }"
    >
      <div>横向卡片最大平铺排数</div>
      <van-slider
        class="chooseDiffSlider"
        bar-height="15"
        v-model="colNum"
        min="3"
        max="10"
      >
        <template #button>
          <div class="custom-button">{{ colNum }}</div>
        </template>
      </van-slider>
      <div>纵向卡片最大平铺排数</div>
      <van-slider
        class="chooseDiffSlider"
        bar-height="15"
        v-model="rowNum"
        min="3"
        max="10"
      >
        <template #button>
          <div class="custom-button">{{ rowNum }}</div>
        </template>
      </van-slider>
      <div>卡片最大堆叠层数</div>
      <van-slider
        class="chooseDiffSlider"
        bar-height="15"
        v-model="pilesNum"
        min="3"
        max="15"
      >
        <template #button>
          <div class="custom-button">{{ pilesNum }}</div>
        </template>
      </van-slider>
      <div>卡片密度</div>
      <van-slider
        class="chooseDiffSlider"
        bar-height="15"
        v-model="Density"
        max="10"
      >
        <template #button>
          <div class="custom-button">{{ Density }}</div>
        </template>
      </van-slider>
      <div>最大卡片种类</div>
      <van-slider
        class="chooseDiffSlider"
        bar-height="15"
        v-model="cardTypeNum"
        min="3"
        max="15"
      >
        <template #button>
          <div class="custom-button">{{ cardTypeNum }}</div>
        </template>
      </van-slider>
    </van-popup>

    <van-button
      color="linear-gradient(to right, #9c88ff, #7f8fa6)"
      @click="restart"
      >👉开始游戏</van-button
    >
    <van-button
      color="linear-gradient(to right, #34495e, #7f8c8d)"
      @click="showChoose = true"
      >⚙设置难度</van-button
    >
  </div>
  <div class="game" v-show="gameStart">
    <div
      class="card-container"
      :style="{
        height: rowNum * 2 * pointHeight + 'px',
        width: colNum * 2 * pointWidth + 'px',
      }"
    >
      <div
        v-for="(card, index) in cardList"
        class="card"
        :class="{ 'is-covered': lists[card[0]][card[1]][card[2]].isCovered }"
        :key="card"
        :style="[
          cardPosition(card),
          {
            'background-color':
              backgroundColorList[lists[card[0]][card[1]][card[2]].cardType],
          },
        ]"
        @click="removeCard(card, index)"
      >
        <img :src="imgList[lists[card[0]][card[1]][card[2]].cardType]" />
      </div>
    </div>
    <div class="remove-prop-container">
      <div
        v-for="(card, index) in removePropCards"
        :key="card"
        class="card"
        :style="{
          left: index * 2 * pointWidth + 'px',
          'background-color': backgroundColorList[card.cardType],
        }"
        v-show="!card.isRemoved"
      >
        <img
          :src="imgList[card.cardType]"
          @click="removePropCard(card, index)"
        />
      </div>
    </div>
    <div
      class="remove-container"
      :style="{ width: colNum * 2 * pointWidth + 'px' }"
    >
      <div
        v-for="(cardType, index) in removeList"
        :key="cardType"
        class="card"
        :style="[
          removeCardPostion(index),
          { 'background-color': backgroundColorList[cardType] },
        ]"
      >
        <img :src="imgList[cardType]" />
      </div>
    </div>
    <div class="props">
      <div>
        <van-button
          color="#4cd137"
          @click="removeThreeCards"
          :disabled="removeHasUsed"
          ><svg
            t="1665368771294"
            class="svg-icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="5345"
            width="200"
            height="200"
          >
            <path
              d="M474.3 480.7L113.9 836.6c-20.2 19-21.2 50.7-2.3 71 0.7 0.8 1.5 1.5 2.3 2.3 9.5 10.4 23 16.1 37.1 15.7 14.1 0.4 27.6-5.3 37.1-15.7l323.3-319.1 323.3 319.1c9.5 10.4 23.1 16.1 37.1 15.7 14.1 0.4 27.6-5.3 37.1-15.7 20.2-19 21.2-50.7 2.3-71-0.7-0.8-1.5-1.5-2.3-2.3L548.5 480.7c-19.9-20.5-52.6-21-73.1-1.1-0.4 0.3-0.8 0.7-1.1 1.1z m0-366.3L113.9 470.2c-20.2 19-21.2 50.7-2.3 71 0.7 0.8 1.5 1.5 2.3 2.3 9.5 10.4 23 16.1 37.1 15.7 14.1 0.4 27.6-5.3 37.1-15.6l323.3-319.2 323.3 319.2c9.5 10.4 23.1 16.1 37.1 15.6 14 0.4 27.6-5.3 37.1-15.6 20.2-19 21.2-50.7 2.3-71-0.7-0.8-1.5-1.5-2.3-2.3L548.5 114.4c-19.9-20.5-52.6-21-73.1-1.1l-1.1 1.1z"
              p-id="5346"
            ></path></svg
        ></van-button>
      </div>
      <div>
        <van-button color="#1abc9c" @click="resort" :disabled="resortHasUsed"
          ><svg
            t="1665368946247"
            class="svg-icon"
            viewBox="0 0 1162 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6267"
            width="200"
            height="200"
          >
            <path
              d="M1015.265248 720.230902h-8.677481a34.709923 34.709923 0 0 1-26.032442-52.064884 433.874038 433.874038 0 0 0-216.937019-538.003807 425.196557 425.196557 0 0 0-485.938922 86.774808 43.387404 43.387404 0 0 1-60.742365-60.742365A520.648845 520.648845 0 0 1 807.00571 52.064885 511.971364 511.971364 0 0 1 1058.652652 694.19846a43.387404 43.387404 0 0 1-43.387404 26.032442zM581.39121 1023.942729a538.003807 538.003807 0 0 1-225.614499-52.064885 520.648845 520.648845 0 0 1-260.324423-624.778614 43.387404 43.387404 0 0 1 60.742366-26.032442 43.387404 43.387404 0 0 1 26.032442 52.064884 433.874038 433.874038 0 0 0 216.937019 520.648845 425.196557 425.196557 0 0 0 485.938922-86.774807 43.387404 43.387404 0 1 1 60.742365 60.742365 485.938922 485.938922 0 0 1-364.454192 156.194654z"
              p-id="6268"
            ></path>
            <path
              d="M199.582057 494.616403c-17.354962 0-26.032442 0-34.709923-17.354962l-34.709923-52.064884-60.742365 52.064884a43.387404 43.387404 0 0 1-60.742365-8.67748 43.387404 43.387404 0 0 1 8.677481-60.742366l95.452288-78.097326c8.677481-8.677481 26.032442-17.354962 34.709923-8.677481s26.032442 8.677481 26.032442 17.354961L234.29198 433.874038c17.354962 17.354962 8.677481 43.387404-17.354961 60.742365zM1015.265248 746.263345h-8.677481l-26.032442-26.032443-52.064885-95.452288c-17.354962-17.354962-8.677481-43.387404 17.354962-60.742365a60.742365 60.742365 0 0 1 60.742365 17.354961l26.032442 60.742366 60.742366-52.064885a52.064885 52.064885 0 0 1 60.742365 8.677481c8.677481 17.354962 8.677481 52.064885-8.677481 60.742365l-104.129769 78.097327z"
              p-id="6269"
            ></path></svg
        ></van-button>
      </div>
      <div>
        <van-button color="#2980b9" @click="gameStart=false;showChooseDifficulty=true">
          <svg
            t="1665369011978"
            class="svg-icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="7217"
            width="200"
            height="200"
          >
            <path
              d="M0 192v640c0 70.7 57.3 128 128 128h352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h352c17.7 0 32-14.3 32-32s-14.3-32-32-32H128C57.3 64 0 121.3 0 192z"
              p-id="7218"
            ></path>
            <path
              d="M1013.3 535.7L650.9 863.3c-41.1 37.2-106.9 8-106.9-47.5V685c0-4.4-3.6-8-8-8H224c-17.7 0-32-14.3-32-32V379c0-17.7 14.3-32 32-32h312c4.4 0 8-3.6 8-8V208.1c0-55.5 65.8-84.7 106.9-47.5l362.4 327.6c14.1 12.8 14.1 34.8 0 47.5z"
              p-id="7219"
            ></path>
          </svg>
        </van-button>
      </div>
    </div>
  </div>
  <div class="gameJudge" v-if="isDefeated || isVictory">
    <div class="words" v-if="isVictory">You Win! 🎉</div>
    <div class="words" v-if="isDefeated">You Lose! 😢</div>
    <div class="next">
      <van-button color="#1dd1a1" @click="restart">再来一轮</van-button>
      <van-button color="#c8d6e5" @click="chooseDifficulty"
        >回主菜单</van-button
      >
    </div>
  </div>
</template>

<script>
import icon1 from "../assets/image/1.png";
import icon2 from "../assets/image/2.png";
import icon3 from "../assets/image/3.png";
import icon4 from "../assets/image/4.png";
import icon5 from "../assets/image/5.png";
import icon6 from "../assets/image/6.png";
import icon7 from "../assets/image/7.png";
import icon8 from "../assets/image/8.png";
import icon9 from "../assets/image/9.png";
import icon10 from "../assets/image/10.png";
import icon11 from "../assets/image/11.png";
import icon12 from "../assets/image/12.png";
import icon13 from "../assets/image/13.png";
import icon14 from "../assets/image/14.png";
import icon15 from "../assets/image/15.png";
// import func from 'vue-editor-bridge'
let removeFlag = false;
let removingType = -1;
let removingIndex = 0;
const gradientColor = {
  "0%": "#3fecff",
  "100%": "#6149f6",
};
export default {
  name: "App",
  components: {},
  data() {
    return {
      lists: [],
      cardList: [],
      removeList: [],
      showOverlay: true,
      showChooseDifficulty: false,
      showChoose: false,
      gameStart: false,
      isDefeated: false,
      isVictory: false,
      rowNum: 4,
      colNum: 6,
      pilesNum: 10,
      Density: 2,
      cardTypeNum: 9,
      currentRate: 100,
      rate: 0,
      rateTimer: null,
      gradientColor,
      imgList: [
        icon1,
        icon2,
        icon3,
        icon4,
        icon5,
        icon6,
        icon7,
        icon8,
        icon9,
        icon10,
        icon11,
        icon12,
        icon13,
        icon14,
        icon15,
      ],
      backgroundColorList: [
        "rgb(153, 255, 153)",
        "rgb(255, 200, 180)",
        "rgb(255, 221, 170)",
        "rgb(170, 255, 238)",
        "rgb(204, 255, 153)",
        "rgb(255, 255, 187)",
        "rgb(255, 183, 221)",
        "rgb(153, 255, 255)",
        "rgb(204, 238, 255)",
        "rgb(204, 221, 255)",
        "rgb(153, 255, 255)",
        "rgb(238, 255, 187)",
        "rgb(255, 238, 153)",
      ],
      pointHeight: 23,
      pointWidth: 22,
      removeHasUsed: false,
      removePropCards: [],
      resortHasUsed: false,
    };
  },
  computed: {},
  mounted() {
    let self = this;
    this.rateTimer = window.setInterval(function () {
      self.rate++
      if (self.rate === 100){
        window.clearInterval(self.rateTimer)
        setTimeout(function(){
          self.showChooseDifficulty = true
          self.showOverlay = false
        })
      }
    }, 10);
  },
  methods: {
    //初始化
    init() {
      //使用行数×2 * 列数×2 * 层数的三维网格来实现效果，每个卡片占四个网格，以实现叠卡片时偏1/2卡片的效果
      //pilesNum在range的input里切换后会变成string类型
      //使用*2可以把它变回数字类型
      this.lists = new Array(Number(this.pilesNum)).fill(1).map((item, z) => {
        return new Array(this.colNum * 2).fill(0).map((item, x) => {
          return new Array(this.rowNum * 2).fill(0).map((item, y) => {
            return {
              hasCard: false,
              cardType: -1,
              x,
              y,
              z,
              isCovered: false,
              isRemoved: false,
            };
          });
        });
      });
      //通过随机数来判断该位置是否放卡片，同时还要判断左、下、左下有卡片时不能重复放卡片
      this.lists.forEach((item, z) => {
        for (let x = 0; x < this.colNum * 2; x++) {
          for (let y = 0; y < this.rowNum * 2; y++) {
            if (
              10 * Math.random() < this.Density &&
              (x == 0 || !this.lists[z][x - 1][y].hasCard) &&
              (y == 0 || !this.lists[z][x][y - 1].hasCard) &&
              (x == 0 || y == 0 || !this.lists[z][x - 1][y - 1].hasCard) &&
              (y == this.rowNum * 2 - 1 ||
                x == 0 ||
                !this.lists[z][x - 1][y + 1].hasCard)
            ) {
              //使用cardList来便于管理卡片
              // if (y != this.rowNum * 2 - 1) console.log(x, y, this.lists[z][x][y + 1].hasCard)
              this.cardList.push([z, x, y]);
              this.lists[z][x][y].hasCard = true;
            }
          }
        }
      });
      const cardListLength = this.cardList.length;
      //使卡片数量变成3的倍数
      for (let i = 0; i < cardListLength % 3; i++) {
        const card = this.cardList.shift();
        //cardList存的值是先x坐标再y轴坐标
        this.lists[card[0]][card[1]][card[2]].hasCard = false;
      }
      const tempCardList = [...this.cardList];
      //给卡片加上cardType
      for (let i = tempCardList.length / 3; i > 0; i--) {
        const cardType = Math.floor(Math.random() * this.cardTypeNum);
        //3的倍数来给与卡片类型值
        for (let j = 0; j < 3; j++) {
          //随机一个tempCardList上的一个元素
          const index = Math.floor(Math.random() * tempCardList.length);
          //切除tempCardList里的该元素并获取到
          const card = tempCardList.splice(index, 1)[0];
          //给该卡片赋予cardType的值
          this.lists[card[0]][card[1]][card[2]].cardType = cardType;
        }
      }
      //给卡片加上isCovered
      this.putCovered();
      console.log(this.lists);
    },
    putCovered() {
      this.cardList.forEach((item) => {
        this.lists[item[0]][item[1]][item[2]].isCovered = this.cardList.some(
          (card) => {
            if (
              card[0] > item[0] &&
              card[1] - item[1] >= -1 &&
              card[1] - item[1] <= 1 &&
              card[2] - item[2] >= -1 &&
              card[2] - item[2] <= 1
            ) {
              return true;
            }
          }
        );
      });
    },
    //移卡片
    removeCard(card, index) {
      if (removeFlag) return;
      removeFlag = true;
      this.lists[card[0]][card[1]][card[2]].hasCard = false;
      removingType = this.lists[card[0]][card[1]][card[2]].cardType;
      removingIndex =
        this.removeList.lastIndexOf(removingType) == -1
          ? this.removeList.length
          : this.removeList.lastIndexOf(removingType) + 1;
      setTimeout(() => {
        this.cardList.splice(index, 1)[0];
        this.removeList.splice(removingIndex, 0, removingType);
        this.lists[card[0]][card[1]][card[2]].hasCard = false;
        //加遮罩
        this.putCovered();
        //3消
        this.threeRemove();
        //判断胜负
        this.judgeGame();
        removeFlag = false;
      }, 300);
    },
    //上面堆着的卡片的位置
    cardPosition(card) {
      if (this.lists[card[0]][card[1]][card[2]].hasCard)
        return {
          left: card[1] * this.pointWidth + "px",
          top: card[2] * this.pointHeight + "px",
          "z-index": card[0],
        };
      else {
        return {
          left: removingIndex * 2 * this.pointWidth + "px",
          top: this.rowNum * 2 * this.pointHeight + 150 + "px",
          "z-index": card[0],
        };
      }
    },
    //removelist里面的卡片的位置
    removeCardPostion(index) {
      if (!removeFlag || removingIndex > index)
        return { left: index * 2 * this.pointWidth + "px" };
      else return { left: (index + 1) * 2 * this.pointWidth + "px" };
    },
    //3个消除
    threeRemove() {
      const removeMap = new Map();
      this.removeList.forEach((item, index) => {
        if (!removeMap.has(item)) removeMap.set(item, [index]);
        else removeMap.get(item).push(index);
      });
      for (let key of removeMap.keys()) {
        if (removeMap.get(key).length == 3) {
          this.removeList.splice(removeMap.get(key)[0], 3);
          removeMap.set(key, []);
        }
      }
    },
    //判断胜负
    judgeGame() {
      if (this.removeList.length === 7) {
        this.isDefeated = true;
        this.gameStart = false;
      }
      if (
        this.cardList.length == 0 &&
        this.removePropCards.every((item) => item.isRemoved)
      ) {
        this.isVictory = true;
        this.gameStart = false;
      }
    },
    //重开游戏
    restart() {
      this.showChooseDifficulty = false;
      this.isDefeated = false;
      this.isVictory = false;
      this.gameStart = true;
      this.removeHasUsed = false;
      this.resortHasUsed = false;
      this.lists = [];
      this.cardList = [];
      this.removeList = [];
      this.removePropCards = [];
      this.init();
    },
    //调节难度
    chooseDifficulty() {
      this.isDefeated = false;
      this.isVictory = false;
      this.showChooseDifficulty = true;
    },
    //道具
    removeThreeCards() {
      this.removePropCards = this.removeList.splice(0, 3).map((item) => {
        return {
          cardType: item,
          isRemoved: false,
        };
      });
      this.removeHasUsed = true;
    },
    removePropCard(card, index) {
      this.removePropCards[index].isRemoved = true;
      removingIndex =
        this.removeList.lastIndexOf(card.cardType) == -1
          ? this.removeList.length
          : this.removeList.lastIndexOf(card.cardType) + 1;
      this.removeList.splice(removingIndex, 0, card.cardType);
      //3消
      this.threeRemove();
      //判断胜负
      this.judgeGame();
    },
    resort() {
      //新的坐标点
      for (let i = 0; i < this.cardList.length; i++) {
        const card = this.cardList[i];
        let newCard = [
          Math.floor(Math.random() * this.pilesNum),
          Math.floor(Math.random() * this.colNum * 2),
          Math.floor(Math.random() * this.rowNum * 2),
        ];
        //不断随机出有效的新位置，有效即同层九宫格里面不重复
        while (
          this.cardList.some(
            (item) =>
              item[0] == newCard[0] &&
              newCard[1] - item[1] >= -1 &&
              newCard[1] - item[1] <= 1 &&
              newCard[2] - item[2] >= -1 &&
              newCard[2] - item[2] <= 1
          )
        ) {
          newCard = [
            Math.floor(Math.random() * this.pilesNum),
            Math.floor(Math.random() * this.colNum * 2),
            Math.floor(Math.random() * this.rowNum * 2),
          ];
        }
        this.lists[card[0]][card[1]][card[2]].hasCard = false;
        this.lists[newCard[0]][newCard[1]][newCard[2]].hasCard = true;
        this.lists[newCard[0]][newCard[1]][newCard[2]].cardType =
          this.lists[card[0]][card[1]][card[2]].cardType;
        this.lists[card[0]][card[1]][card[2]].cardType = -1;
        this.cardList[i] = newCard;
      }
      //给卡片加上isCovered
      this.putCovered();
      this.resortHasUsed = true;
    },
  },
};
</script>

<style>
.chooseDifficulty {
  margin: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.chooseDifficultyPopup > div {
  margin-top: 0.5rem;
  max-width: 80%;
  margin: 0 auto;
  text-align: center;
}
.chooseDifficulty .chooseDiffSlider {
  margin: 0.58rem 0;
}

.chooseDifficulty button {
  margin-top: 30px;
}

.card-container {
  margin: 80px auto 20px;
  position: relative;
}

.card {
  position: absolute;
  height: 38px;
  width: 42px;
  box-shadow: 0px 1px 0 0 #fff, 0 8px 0 0 #ddd, 0 8px 0 2px #333, 0 0 0 2px #333;
  transition: all 0.3s ease;
}

img {
  height: 38px;
  width: 42px;
}

.is-covered {
  pointer-events: none;
}

.is-covered::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  opacity: 0.55;
  background: #000;
}

.remove-prop-container {
  position: relative;
  margin: 70px auto 30px;
  height: 50px;
  width: 250px;
}

.remove-container {
  position: relative;
  margin: 0 auto;
  height: 50px;
  width: 250px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.remove-container::after {
  border: 2px solid #000;
  position: absolute;
  left: -2px;
  top: -2px;
  content: "";
  height: 46px;

  width: 306px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
}

.props,
.props > div {
  display: flex;
  justify-content: center;
}
.props button {
  margin: 0 1.2rem;
}

.words {
  font-size: 36px;
  font-weight: bold;
  text-align: center;
  margin-top: 150px;
}

.next {
  display: flex;
  justify-content: center;
  margin: 30px auto;
}
.next button {
  margin: 0.58rem 1.8rem;
}
.custom-button {
  width: 26px;
  color: #fff;
  font-size: 10px;
  line-height: 18px;
  text-align: center;
  background-color: #1989fa;
  border-radius: 100px;
}

.svg-icon {
  width: 2em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: white;
}
</style>
